<template>
  <ui-report title="Packages Report" subtitle="View newly created packages and completed ones." :initial-filters="initialFilters" v-slot="{ filters }">
    <reports-packages-new :filters="filters"></reports-packages-new>
    <reports-packages-completed :filters="filters"></reports-packages-completed>
  </ui-report>
</template>

<script>
export default {
  data () {
    return {
      initialFilters: {
        range: 'since-monday',
      }
    }
  },
}
</script>
